import { List, ListItem } from "@mui/material";
import { VarutsattVeg } from "../../services/RuteplanAPI";
import { IRoutePartProps } from "./RouteDescription";
import varutsattVegIconSource from "../../assets/weatherProneRoadIcon.svg"

export default function VarutsatteVeger(props: IRoutePartProps) {

    return (
        <>
            {props.roadFeatures && props.roadFeatures.varutsatteVeger && props.roadFeatures.varutsatteVeger.length > 0 &&
            <List> 
                {props.roadFeatures.varutsatteVeger.map ((varutsattVeg: VarutsattVeg, index: number) => (
                    <ListItem 
                        key={varutsattVeg.nvdbId + index } 
                        className="roadFeature" 
                        onClick={(event) => {props.onClick(varutsattVeg, event)}}
                        onMouseEnter={() => props.onMouseEnterItem(varutsattVeg)}
                        onMouseLeave={props.onMouseLeaveItem}>
                            <img src={varutsattVegIconSource} height="18" style={{paddingRight:"5px"}} alt="Værutsatt veg icon" title="værutsattVegIcon"/> 
                            {varutsattVeg.nvdbId}
                    </ListItem>
                ))}
            </List>
            }
        </>
    )
}